import { defineMessages } from 'react-intl';

export const messages: {
    title: {
        id: string;
        defaultMessage: string;
        description: string;
    }; subtitle: {
        id: string;
        defaultMessage: string;
        description: string;
    }; itemsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; relationshipsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; appsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; collaboratorsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	title: {
		id: 'twg-microsite-experience.v2.userGraph.title',
		defaultMessage: "{firstName}'s Teamwork Graph",
		description: 'Heading for the user graph section, personalised with the user first name',
	},
	subtitle: {
		id: 'twg-microsite-experience.v2.userGraph.subtitle',
		defaultMessage: 'A year of your work captured automatically',
		description: 'Subtitle beneath the user graph section heading',
	},
	itemsLabel: {
		id: 'twg-microsite-experience.v2.userGraph.itemsLabel',
		defaultMessage: 'Items',
		description: 'Label for the items stat card in the user graph section',
	},
	relationshipsLabel: {
		id: 'twg-microsite-experience.v2.userGraph.relationshipsLabel',
		defaultMessage: 'Relationships',
		description: 'Label for the relationships stat card in the user graph section',
	},
	appsLabel: {
		id: 'twg-microsite-experience.v2.userGraph.appsLabel',
		defaultMessage: 'Apps',
		description: 'Label for the apps stat card in the user graph section',
	},
	collaboratorsLabel: {
		id: 'twg-microsite-experience.v2.userGraph.collaboratorsLabel',
		defaultMessage: 'Collaborators',
		description: 'Label for the collaborators stat card in the user graph section',
	},
});
